import { render, staticRenderFns } from "./ModuleGroupList.vue?vue&type=template&id=f3e75c26&"
import script from "./ModuleGroupList.vue?vue&type=script&lang=js&"
export * from "./ModuleGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports